import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Carousel } from '../../models';
import { CarouselButton } from '../../models/carousel-button.model';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CarouselComponent implements OnInit {
  @Input() carousel: Carousel;
  @Output() buttonClicked: EventEmitter<any> = new EventEmitter();

  slideIndex = 0;
  maxSlideIndex = 0;

  @HostListener('swiperight', ['$event']) onSwipeRight() {
    if (this.slideIndex <= 0) {
      return;
    }
    this.scrollToPreviousSlide();
  }

  @HostListener('swipeleft', ['$event']) onSwipeLeft() {
    if (this.slideIndex >= this.maxSlideIndex - 1) {
      return;
    }
    this.scrollToNextSlide();
  }

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.maxSlideIndex = (this.carousel.slides || []).length;
  }

  scrollToPreviousSlide() {
    this.scrollToSlide(--this.slideIndex);
  }
  scrollToNextSlide() {
    this.scrollToSlide(++this.slideIndex);
  }

  scrollToSlide(index, forced?: boolean) {
    if (index < 0 || index >= this.maxSlideIndex) {
      return;
    }
    if (forced) {
      this.slideIndex = index;
    }
    const carouselInner = this.elementRef.nativeElement.querySelector('.carousel-inner');
    const slideWidth = this.elementRef.nativeElement.querySelector('.slide').clientWidth;
    const offset = index * (+slideWidth + 10); // Gap between slides is 10px

    carouselInner['style'].transform = `translateX(-${offset}px)`;
  }

  onButtonClicked(button: CarouselButton) {
    if (button.url) {
      window.open(button.url, '_blank', 'noopener,noreferrer');
    } else {
      this.buttonClicked.emit(button);
    }
    setTimeout(() => (button.buttonAlreadyClicked = false), 2000);
  }
}
